import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "@/lib/toast";

// Routes that moved to per-domain SPAs in Phase 4 of the domain taxonomy
// reorg. Operators with stale bookmarks pointing at console.g1.network/<x>
// land on the new host with the same path.
const PATH_PREFIX_TO_HOST: Array<[string, string, string]> = [
	["/entities", "https://review.g1.network", "Review"],
	["/reviews", "https://review.g1.network", "Review"],
	["/authors", "https://review.g1.network", "Review"],
	["/comparisons", "https://review.g1.network", "Review"],
	["/answers", "https://review.g1.network", "Review"],
	["/faq", "https://review.g1.network", "Review"],
	["/pages", "https://review.g1.network", "Review"],
	["/media", "https://review.g1.network", "Review"],
	["/taxonomies", "https://review.g1.network", "Review"],
	["/moderation", "https://review.g1.network", "Review"],
	["/freshness", "https://review.g1.network", "Review"],
	["/ranking", "https://review.g1.network", "Review"],
	["/external-signals", "https://review.g1.network", "Review"],
	["/performance", "https://review.g1.network", "Review"],
	["/audit-log", "https://review.g1.network", "Review"],
	["/quality", "https://review.g1.network", "Review"],
	["/templates", "https://template.g1.network", "Template"],
	["/news", "https://news.g1.network", "News"],
	["/rss-sources", "https://news.g1.network", "News"],
	["/live-blogs", "https://news.g1.network", "News"],
];

function resolveTarget(pathname: string): { host: string; domain: string } | null {
	for (const [prefix, host, domain] of PATH_PREFIX_TO_HOST) {
		if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
			return { host, domain };
		}
	}
	return null;
}

export function LegacyRedirect() {
	const location = useLocation();
	const target = resolveTarget(location.pathname);

	useEffect(() => {
		if (!target) return;
		toast.info(`Moved to ${target.domain} domain — redirecting…`);
		const url = `${target.host}${location.pathname}${location.search}${location.hash}`;
		window.location.replace(url);
	}, [target, location.pathname, location.search, location.hash]);

	if (!target) return null;

	return (
		<div className="flex min-h-[40vh] items-center justify-center text-sm text-muted">
			Redirecting to {target.host}…
		</div>
	);
}

export const LEGACY_PATH_PREFIXES = PATH_PREFIX_TO_HOST.map(([p]) => p);
